import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	parentTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	parentTitle: {
		id: 'issue-field-parent-readview-full.parent.summary.parent-title',
		defaultMessage: 'Click to visit {label}',
		description:
			'Aria Label for the link that takes the user to the parent issue - Click to visit [parent label]',
	},
});
export default messages;
